<template>

  <el-dialog :visible.sync="visible" width="95%" append-to-body :close-on-click-modal="false" @closed="onClosed">

    <template slot="title">

      <div class="doc-dialog-header">

        <span class="doc-dialog-title">{{ dialogTitle }}</span>

        <div v-if="showViewToolbar" class="doc-dialog-actions">

          <el-button-group>

            <workflow-doc-buttons biz-type="productionReport" :biz-id="form.id" perm="production:productionReport" :approve-status="String(form.approveStatus || '0')" @approve="approve(true)" @unapprove="approve(false)" @done="onWorkflowDone" />

            <el-button v-if="(isAuth('production:productionReport:update') || isAuth('production:productionReport:save')) && canEditDoc" type="primary" size="small" @click="readonly = false">修改</el-button>

            <el-button v-if="isAuth('production:productionReport:delete') && canEditDoc" type="primary" size="small" @click="remove">删除</el-button>

          </el-button-group>

        </div>

      </div>

    </template>

    <el-form ref="dataForm" :model="form" :rules="rules" label-width="100px">

      <el-row :gutter="10">

        <el-col :span="6" :xs="24" :sm="12" :md="6"><el-form-item label="报工单号"><el-input v-model="form.code" :disabled="formDisabled || !!form.id || codeReadonly" :placeholder="codeReadonly ? '保存时按单据规则生成' : '请输入报工单号'" /></el-form-item></el-col>

        <el-col :span="6" :xs="24" :sm="12" :md="6"><el-form-item label="日期" prop="bizDate"><el-date-picker v-model="form.bizDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" :disabled="formDisabled" style="width:100%" /></el-form-item></el-col>

        <el-col :span="8" :xs="24" :sm="12" :md="8">

          <el-form-item label="生产工单" prop="productionOrderId">

            <el-input :value="form.productionOrderCode" readonly placeholder="选择工单">

              <el-button v-if="!formDisabled" slot="append" @click="pickOrder">选择</el-button>

            </el-input>

          </el-form-item>

        </el-col>

        <el-col :span="4" :xs="24" :sm="12" :md="4" v-if="!formDisabled">

          <el-form-item label-width="0px">

            <el-button type="primary" size="small" :disabled="!form.productionOrderId" @click="fillRouting">按工艺带出</el-button>

          </el-form-item>

        </el-col>

      </el-row>

      <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :disabled="formDisabled" /></el-form-item>

      <el-table :data="form.lines" border :header-cell-style="headStyle">

        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />

        <el-table-column prop="processCode" label="工序编码" min-width="120" header-align="center" align="left" />

        <el-table-column prop="processName" label="工序名称" min-width="140" header-align="center" align="left" />

        <el-table-column prop="remainReportQty" label="可报工" width="100" header-align="center" align="left" />

        <el-table-column label="报工数量" width="165" header-align="center" align="left">

          <template slot-scope="s"><el-input-number v-model="s.row.reportQty" :disabled="formDisabled" :min="0" :precision="2" size="small" style="width:100%" /></template>

        </el-table-column>

        <el-table-column label="报废数量" width="165" header-align="center" align="left">

          <template slot-scope="s"><el-input-number v-model="s.row.scrapQty" :disabled="formDisabled" :min="0" :precision="2" size="small" style="width:100%" /></template>

        </el-table-column>

        <el-table-column label="工时" width="165" header-align="center" align="left">

          <template slot-scope="s"><el-input-number v-model="s.row.laborHours" :disabled="formDisabled" :min="0" :precision="2" size="small" style="width:100%" /></template>

        </el-table-column>

        <el-table-column v-if="laborAmountInputEnabled" label="人工金额" width="130" header-align="center" align="left">

          <template slot-scope="s"><el-input-number v-model="s.row.laborAmount" :disabled="formDisabled" :min="0" :precision="3" size="small" style="width:100%" /></template>

        </el-table-column>

        <el-table-column v-if="!formDisabled" label="操作" width="70" header-align="center" align="center" fixed="right">
          <template slot-scope="s"><el-button type="text" size="small" @click="removeLine(s.$index)">移除</el-button></template>
        </el-table-column>

      </el-table>

    </el-form>

    <span slot="footer">

      <el-button @click="visible = false">取消</el-button>

      <el-button v-if="!formDisabled" type="primary" @click="save">保存</el-button>

    </span>

    <el-dialog title="选择生产工单" :visible.sync="orderDlg" width="700px" append-to-body>

      <el-table :data="orders" border :header-cell-style="headStyle" @row-click="selectOrder">

        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />

        <el-table-column prop="productionOrderCode" label="工单号" min-width="140" header-align="center" align="left" />

        <el-table-column prop="materialCode" label="成品编码" min-width="120" header-align="center" align="left" />

        <el-table-column prop="orderStatus" label="状态" width="90" header-align="center" align="left">

          <template slot-scope="s">{{ s.row.orderStatus === '1' ? '已下达' : s.row.orderStatus === '3' ? '已完工' : (s.row.orderStatus || '') }}</template>

        </el-table-column>

      </el-table>

    </el-dialog>

  </el-dialog>

</template>



<script>

import WorkflowDocButtons from '../../components/WorkflowDocButtons.vue'

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import { isWorkflowEditable } from '../../utils/workflow'



function today() {

  const d = new Date()

  const p = n => String(n).padStart(2, '0')

  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' 00:00:00'

}



export default {

  name: 'ProductionReportAddOrUpdate',

  components: { WorkflowDocButtons },

  data() {

    return {

      visible: false,

      readonly: false,

      codeReadonly: false,

      orderDlg: false,

      orders: [],

      ordersRequestId: 0,

      permCodes: [],

      laborAmountInputEnabled: false,

      form: { lines: [], productionOrderCode: '' },

      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' },

      rules: {

        bizDate: [{ required: true, message: '日期不能为空', trigger: 'change' }],

        productionOrderId: [{ required: true, message: '请选择生产工单', trigger: 'change' }]

      }

    }

  },

  computed: {

    canEditDoc() { return isWorkflowEditable(this.form.workflowStatus, this.form.approveStatus) },

    formDisabled() { return this.readonly || !this.canEditDoc },

    showViewToolbar() { return this.readonly && !!this.form.id },

    dialogTitle() {

      if (this.readonly) return '报工详情'

      return this.form.id ? '修改报工' : '新增报工'

    }

  },

  created() {

    this.loadPerms()

    this.loadOrders()

    this.loadLaborSwitch()

  },

  methods: {

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },

    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'productionReport' }).then(res => {
        if (!this.visible || this.form.id) return
        const rule = res.data || {}
        this.codeReadonly = !!rule.codeReadonly
        if (rule.previewCode) this.form.code = rule.previewCode
      }).catch(() => {})
    },

    loadOrders(includeId) {
      const include = includeId || (this.form && this.form.productionOrderId) || ''
      const requestId = ++this.ordersRequestId
      return request.get('/production/order/ordersForBiz', { params: { includeProductionOrderId: include } })
        .then(res => { if (requestId === this.ordersRequestId) this.orders = res.data || [] })
        .catch(() => { if (requestId === this.ordersRequestId) this.orders = [] })
    },

    pickOrder() {
      this.orderDlg = true
      this.loadOrders(this.form.productionOrderId)
    },

    selectOrder(row) {
      if (!row) return
      this.form.productionOrderId = row.productionOrderId
      this.form.productionOrderCode = row.productionOrderCode || ''
      this.form.lines = []
      this.orderDlg = false
      this.$nextTick(() => this.fillRouting())
    },

    removeLine(index) {
      this.form.lines.splice(index, 1)
    },

    onWorkflowDone() {
      this.$emit('refreshDataList')
      if (this.form && this.form.id) this.init(this.form.id, true)
    },

    loadLaborSwitch() {

      request.get('/production/report/laborAmountInputEnabled').then(res => {

        this.laborAmountInputEnabled = !!(res.data && res.data.enabled)

      }).catch(() => { this.laborAmountInputEnabled = false })

    },

    onClosed() {

      this.readonly = false

      this.orderDlg = false

      this.form = { lines: [], productionOrderCode: '' }

    },

    init(idOrRow, readonly) {

      this.visible = true

      this.readonly = !!readonly

      this.codeReadonly = false

      if (this.readonly && idOrRow) {

        const openView = prefill => {

          const bizDate = prefill.bizDate && String(prefill.bizDate).length <= 10 ? prefill.bizDate + ' 00:00:00' : (prefill.bizDate || '')

          this.form = { id: prefill.id, code: prefill.code || '', bizDate, productionOrderId: prefill.productionOrderId || '', productionOrderCode: prefill.productionOrderCode || '', approveStatus: String(prefill.approveStatus || '0'), remark: prefill.remark || '', lines: [] }
          this.loadOrders(this.form.productionOrderId).then(() => {
            if (!this.form.productionOrderCode && this.form.productionOrderId) {
              const hit = (this.orders || []).find(o => o.productionOrderId === this.form.productionOrderId)
              if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
            }
          })

          request.get('/production/report/lines', { params: { id: prefill.id } }).then(res => { this.form.lines = res.data || [] }).catch(() => {})

        }

        const id = typeof idOrRow === 'object' ? idOrRow.id : idOrRow

        if (id) {

          request.get('/production/report/info', { params: { id } }).then(res => {
            openView(res.data || (typeof idOrRow === 'object' ? idOrRow : { id }))
          }).catch(() => { openView(typeof idOrRow === 'object' ? idOrRow : { id }) })

        }

        return

      }

      const prefill = idOrRow && typeof idOrRow === 'object' ? idOrRow : null

      this.form = { code: '', bizDate: today(), productionOrderId: (prefill && prefill.productionOrderId) || '', productionOrderCode: (prefill && prefill.productionOrderCode) || '', remark: '', lines: [] }
      this.resolveCode()
      if (this.form.productionOrderId) {
        const orderId = this.form.productionOrderId
        this.loadOrders(orderId).then(() => {
          if (this.form.productionOrderId !== orderId || this.form.productionOrderCode) return
          const hit = (this.orders || []).find(order => order.productionOrderId === orderId)
          if (hit) this.form.productionOrderCode = hit.productionOrderCode || ''
        })
      }

    },

    approve(pass) {

      const id = this.form.id

      this.$confirm(pass ? '确定审核?' : '确定弃审?', '提示', { type: 'warning' }).then(() => {

        request.post(pass ? '/production/report/approve' : '/production/report/unapprove', { id }).then(() => {

          this.$message.success(pass ? '审核成功' : '弃审成功')

          this.visible = false

          this.$emit('refreshDataList')

        }).catch(() => {})

      }).catch(() => {})

    },

    remove() {

      this.$confirm('确定删除这张未审核报工单?', '提示', { type: 'warning' }).then(() => {

        request.post('/production/report/delete', { id: this.form.id }).then(() => { this.$message.success('已删除'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})

      }).catch(() => {})

    },

    save() {

      this.$refs.dataForm.validate(valid => {

        if (!valid) return

        const lines = (this.form.lines || []).filter(line => Number(line.reportQty) > 0)

        if (!lines.length) { this.$message.warning('请按工艺带出并填写报工数量'); return }

        request.post('/production/report/save', {

          id: this.form.id, code: this.form.code, bizDate: this.form.bizDate, productionOrderId: this.form.productionOrderId, remark: this.form.remark,

          lines: lines.map(line => ({

            orderRoutingId: line.orderRoutingId, processId: line.processId, processCode: line.processCode, processName: line.processName,

            reportQty: line.reportQty, scrapQty: line.scrapQty, laborHours: line.laborHours,

            laborAmount: this.laborAmountInputEnabled ? (line.laborAmount || 0) : 0

          }))

        }).then(() => { this.$message.success('保存成功'); this.visible = false; this.$emit('refreshDataList') }).catch(() => {})

      })

    },

    fillRouting() {
      const form = this.form
      const orderId = form.productionOrderId
      if (!orderId) return
      request.get('/production/report/routingLines', { params: { productionOrderId: orderId, excludeReportId: form.id || '' } }).then(res => {
        if (!this.visible || this.form !== form || form.productionOrderId !== orderId) return
        form.lines = (res.data || []).map(row => Object.assign({ reportQty: row.remainReportQty, scrapQty: 0, laborHours: 0, laborAmount: 0 }, row))
        if (!form.lines.length) this.$message.warning('没有可报工工序')

      }).catch(() => {})

    }

  }

}

</script>



<style scoped>

.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }

.doc-dialog-title { font-size: 16px; font-weight: 600; }

.doc-dialog-actions .el-button { margin-left: 0; }

</style>


